import { render, staticRenderFns } from "./stock-data-table.vue?vue&type=template&id=4d4bb069&scoped=true&lang=pug"
import script from "./stock-data-table.vue?vue&type=script&lang=js"
export * from "./stock-data-table.vue?vue&type=script&lang=js"
import style0 from "./stock-data-table.vue?vue&type=style&index=0&id=4d4bb069&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4bb069",
  null
  
)

export default component.exports